<template>
	<div
		class="request-status__container"
		:class="{ 'request-status__container--absolute': isAbsolute }"
	>
		<div
			v-if="requestStatus.loading || requestStatus.error"
			class="request-status__status"
			:class="{ 'request-status__status--absolute': isAbsolute }"
		>
			<v-progress-circular
				v-if="requestStatus.loading"
				:indeterminate="true"
				:size="48"
				color="primary"
			/>
			<div v-if="requestStatus.error" class="text-center">
				<h4>{{ errorMessage || $t('request-status.error-message') }}</h4>
				<v-btn class="primary ma-4" @click="onTryAgain()">{{ $t('request-status.try-again') }}</v-btn>
			</div>
		</div>
		<slot v-if="!requestStatus.loading && !requestStatus.error"></slot>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'RequestStatusIndicator',
	props: {
		requestKey: {
			type: String,
			required: true,
		},
		isAbsolute: {
			type: Boolean,
			default: false,
		},
		errorMessage: String,
	},
	computed: {
		...mapState({
			requestStatus(state) {
				return state.requestStatus[this.requestKey];
			},
		}),
	},
	methods: {
		onTryAgain() {
			this.$emit('try-again');
		},
	},
};
</script>

<style>
.request-status__container {
	width: 100%;
	height: 100%;
	position: relative;
	min-height: 100px;
}

.request-status__container--absolute {
	position: absolute;
}

.request-status__status {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: white;
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: center;
}

.request-status__status--absolute {
	background-color: rgba(255, 255, 255, 0.7);
}
</style>